import { Injectable } from '@angular/core';
import {JWTToken} from "../interfaces/JWTToken";
import {AppNavigator, NavigatorTarget} from "../../services/app-navigator";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MerchantLoginService {

  constructor(private appNavigator: AppNavigator) { }

  redirectToLogin(result: JWTToken | null): void {
    if(result !== null)
    {
      if (result.user.forceChangePassword) {
        this.appNavigator.navigateTo({ target: NavigatorTarget.merchantNewPassword })
      } else {
        const jsonString = JSON.stringify(result);
        const encodedString = encodeURIComponent(jsonString);
        let url = environment.merchantPortalUrl;
        url = `${url}/login/${encodedString}`;
        window.location.href = url;
      }
    }
    // Else, do nothing.
  }
}
